module.exports = __webpack_public_path__ + "media/images/remittees_6-d888f23dccffe9e22174eb9f5cdfaff4.jpg";